export default __webpack_public_path__ + "static/media/Frame 1.922c426c.svg";